/*
reporting handles volatile data. 
In the UI layer, we "watch" for changes in that data.

TODO: bubble up server errors.
*/
// ** Redux Imports

// import { getFromServerTopic } from "@utility/slice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { logFilter } from "@logging";
import { talkToServer } from "@helpers/servercomms";
import { IDLE, LOADING } from "@src/constants";
// import { formatDateTime } from "../helpers/utils";

export const portfolioReportRefresh = createAsyncThunk(
  "portfolioReportRefresh",
  async (options, api) => {
    const request = {
      context: {
        topic: "report",
        action: "portfolio_refresh",
        options,
        useCache: false,
      },
    };
    const state = api.getState();
    if (false) logFilter(tag, "here is state", state, options);
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const reportDataSlice = createSlice({
  name: "reportData",
  initialState: {
    // add any default values we might care about here
    lastError: null,
    portfoliodata: [],
    iterations: 0,
    status: IDLE,
  },
  reducers: {
    clearPortfolioData: (state) => {
      state.portfoliodata = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(portfolioReportRefresh.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(portfolioReportRefresh.fulfilled, (state, action) => {
        const tag = "portfolioReportRefresh";
        logFilter(tag, "portfolioReportRefresh.fulfilled", state, action);
        state.status = IDLE;
        if (action.payload) {
          if (action.payload.response.rc === "OK") {
            state.portfoliodata = action.payload.response.payload.rows;
          }
        }
      });
  },
});

export const { clearPortfolioData } = reportDataSlice.actions;

export default reportDataSlice.reducer;
